export default __webpack_public_path__ + "static/media/tx_schools_2024_2025.4027ec80.geojson";